import { render, staticRenderFns } from "./SaleEditProductsWithNotEnoughInStockGroupSelect.vue?vue&type=template&id=513470cf&scoped=true"
import script from "./SaleEditProductsWithNotEnoughInStockGroupSelect.vue?vue&type=script&lang=ts"
export * from "./SaleEditProductsWithNotEnoughInStockGroupSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513470cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513470cf')) {
      api.createRecord('513470cf', component.options)
    } else {
      api.reload('513470cf', component.options)
    }
    module.hot.accept("./SaleEditProductsWithNotEnoughInStockGroupSelect.vue?vue&type=template&id=513470cf&scoped=true", function () {
      api.rerender('513470cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditProductsWithNotEnoughInStockGroupSelect.vue"
export default component.exports